import { isBefore, parseISO } from "date-fns";

export function chartingDeadlineHasPassed(deadlineToChart: string) {
  const deadlineToChartDate = parseISO(deadlineToChart);
  const now = new Date();
  return isBefore(deadlineToChartDate, now);
}
